import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { DropzoneDirective, DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import { AlertService } from 'src/app/services/alert.service';
import { RegionService } from 'src/app/services/region.service';
import { UserSessionService } from 'src/app/services/usersession.service';
import { Location } from '@angular/common';
import { RegisterService } from 'src/app/services/register.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss']
})
export class PopupComponent implements OnInit {



  res: any;
  newapplyitemlist: any[] = [];
  dataSource = new MatTableDataSource(this.newapplyitemlist);

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild('searchInput', { static: true }) searchInput: ElementRef;

  displayedColumns: string[] = [

    'rule',
    'id',
    'name',
    'actions',
  ];
  payfeesform: FormGroup;
  selectedapplicationList: any;
  newApplicant: any;
  public isfiledyes: boolean = false;
  selectedFileName: any;
  filesResult: any;
  districtNameList: any = [];
  public requiredText: boolean = false;
  dirLists: any = [];
  totalval: number = 0;
  enclosed: boolean = false;
  affidavit_enclosed: boolean = false;
  public showSave: boolean = true;
  isEdit: boolean = false;
  districtNameListCopy: any[];
  mapurl: any;
  lat: number;
  long: number;

  constructor(
    public dialogRef: MatDialogRef<PopupComponent>,
    private router: Router,
    private formBuilder: FormBuilder,
    private userSessionService: UserSessionService,
    private alertService: AlertService,
    private _location: Location,
    private sanitizer: DomSanitizer,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { 
    if(this.data)
    {
      //   let = url = "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d4013436.3643496064!2d78.28850260000002!3d10.78283645!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2s{{data.data.lat}}%2C{{data.data.long}}!5e0!3m2!1sen!2sin!4v1620884967971!5m2!1sen!2sin"
      // this.url = this.sanitizer.bypassSecurityTrustResourceUrl()
    }
this.lat = 13.068777;
this.long =  80.564735;
  }

  ngOnInit(): void {
   if(this.data.data){
    this.someFn(13.068777, 80.564735);
   }
    // this.intializeValidators();
    // this.payfeesform.controls['appln_id'].setValue(this.data.value.application_code);
    // this.payfeesform.controls['appln_fees'].setValue(this.data.value.fees)
  }
  intializeValidators() {
    this.payfeesform = this.formBuilder.group({
      appln_id: [],
      appln_fees: [],
    });
  }

  validateFormControl() {
    Object.keys(this.payfeesform.controls).forEach(field => {
      const control = this.payfeesform.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true
        });
      }
    })
  }



  onCancel() {
    this.dialogRef.close();
  }

  onSubmit() {
    let user_id = this.userSessionService.userId();
  }

  someFn(param1,param2){  //call this function from html
    let url = `https://maps.google.com/maps?q=${param1},${param2}&hl=es;z=14&amp;output=embed` // notice carefully the backticks dont confuse it with quotes ('' or " ")
  this.mapurl =  this.sanitizer.bypassSecurityTrustResourceUrl(url);
 // this.mapurl =  url;
 }
 
}
